import React from 'react';
import './Navbar.css';

export default function Navbar({
  user,
  organization,
  objects,      // Ostavljamo prop ali ga ne koristimo
  onLogout,
  page,
  setPage,
  theme,
  setTheme
}) {
  return (
    <header className="navbar-container">
      <div className="navbar-left">
        <div className="navbar-header">
          <h1 className="navbar-title">🎁 vouppy Dashboard</h1>

          {/* Theme Toggle Button */}
          <button
            className="theme-toggle-btn"
            onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
            aria-label="Toggle theme"
          >
            {theme === 'light' ? '🌙' : '☀️'}
          </button>
        </div>

        {/* Demo User - ažurirano sa wrapper divom za info */}
        <div className="demo-user">
          <div className="demo-user-info">
            👤 {user?.real_name}
          </div>
          <button className="logout-button" onClick={onLogout}>
            Odjavi se
          </button>
        </div>

        {/* Navigation Tabs */}
        <nav className="navbar-nav">
          <button
            className={page === "stats" ? "active" : ""}
            onClick={() => setPage("stats")}
          >
            📊 Analitika
          </button>
          <button
            className={page === "upload" ? "active" : ""}
            onClick={() => setPage("upload")}
          >
            📤 Kreiraj vaučere
          </button>
          <button
            className={page === "vouchers" ? "active" : ""}
            onClick={() => setPage("vouchers")}
          >
            📋 Izveštaj vaucera
          </button>
        </nav>
      </div>

      {/* Right Side - samo organization info */}
      <div className="navbar-right">
        <div className="organization-info">
          <div>🏢 {organization?.organization_name} - {organization?.organization_city}</div>
          <div>{organization?.organization_address}</div>
          <div>{organization?.organization_telephone}</div>
          <div>{organization?.organization_email}</div>
        </div>
      </div>
    </header>
  );
}
